import { useState, useEffect, useContext } from "react";

import { loginContext, customerContext } from "../context/contexts";
import { getKeyByValue } from "../context/contextmanager";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box, TextField, MenuItem, Card } from "@mui/material";
import { Button } from "@mui/material";
import { getobj, updateobj, dltobj } from "../apicall/apicall";
import { useLocation } from "react-router-dom";
import { timeStamp } from "../apicall/commonFunction";
import {
  StyledTableRow,
  StyledTableCell,
  boxStyle,
  headerStyle,
} from "../style/style";
import ArrowBack from "@mui/icons-material/ArrowBack";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Pagination from "@mui/material/Pagination";
//import { useLocation } from "react-router-dom";

export default function HubDevices() {
  const [devices, setdevice] = useState();
  const [page, setpage] = useState(
    sessionStorage.getItem("page_number")
      ? parseInt(sessionStorage.getItem("page_number"))
      : 1,
  );
  const [totalpage, setpaget] = useState();
  const [refresh, setrefresh] = useState(false);
  const context = useContext(loginContext);
  const context2 = useContext(customerContext);
  const [loaded, setloaded] = useState(true);
  const loc = useLocation();

  const handlePagechange = (event, value) => {
    setpage(value);
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "device/get-device/0/" +
      "?page=" +
      value +
      "&hub=" +
      context.hub;
    const d = getobj(url);
    d.then(function (res) {
      setdevice(res.results);
    });
  };

  useEffect(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "device/get-device/0/" +
      "?hub=" +
      context.hub +
      "&page=" +
      page;
    const d = getobj(url);
    d.then(function (res) {
      if (res.count % 5 > 0) {
        setpaget(Math.floor(res.count / 5) + 1);
      } else {
        setpaget(Math.floor(res.count / 5));
      }
      setdevice(res.results);
      setloaded(false);
    });
  }, [refresh, context.hub, page]);
  const handleClick = (id) => {
    if (loc.pathname === "/admin") {
      context.setid(id);
      const nm = getKeyByValue(context.page, true);
      sessionStorage.setItem("page_number", page);
      context.setpage({
        ...context.page,
        [nm]: false,
        deviceDetail: true,
      });
    } else if (loc.pathname === "/customer") {
      context.setid(id);
      const nm = getKeyByValue(context2.manage, true);
      context2.setmanage({
        ...context2.manage,
        [nm]: false,
        deviceDetail: true,
      });
    } else if (loc.pathname === "/user") {
      context.setid(id);
      const nm = getKeyByValue(context2.manage, true);
      context2.setmanage({
        ...context2.manage,
        [nm]: false,
        deviceDetail: true,
      });
    }
  };
  const handleaction = (id, val, type) => {
    // console.log(id, val);

    if (val === "Detail") {
      sessionStorage.setItem("page", "hub");
      sessionStorage.setItem("page_number", page);
      handleClick(id);
    } else if (val === "Delete") {
      if (type === "NA") {
        alert("Are you sure! The device will be deleted");
      } else {
        alert(
          "The Device and sim will be deactivated. To delete it permanently please contact admin.",
        );
      }
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      const res = dltobj(url, { id: id });
      res.then((r) => {
        if (r["Message"] === "Device deleted successfully") {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Successfully deleted.", "Deleted", 2000);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Could not delete.", "Failed", 2000);
        }
      });
    } else {
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      let status;
      if (val === "Activate") {
        status = true;
      } else {
        status = false;
      }
      const data = { id: id, active_status: status };
      const res = updateobj(url, data);
      res.then(function (data) {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success("Status Updated.", "Updated", 2000);

        setrefresh(!refresh);
      });
      // console.log(data);
    }
  };

  return (
    <div>
      <Card sx={boxStyle}>
        <Card sx={headerStyle}>Hub Devices/{context.hubId}</Card>
      </Card>
      <Button
        sx={boxStyle}
        startIcon={<ArrowBack />}
        onClick={() => {
          const nm = getKeyByValue(context.page, true);

          context.setpage({
            ...context.page,
            [nm]: false,
            Hubs: true,
          });
        }}
      ></Button>
      {loaded ? (
        <img
          src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
          alt="loading..."
        />
      ) : (
        <Card sx={boxStyle}>
          <Box sx={{ marginRight: "30px" }}>
            {devices && devices.length > 0 ? (
              <Box>
                <TableContainer>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>
                          <b>Device Group</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>Model</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>Bluetooth ID</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>IMEI</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>Status</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>Last Active</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b> Comments</b>
                        </StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {devices &&
                        devices.map((device) => (
                          <StyledTableRow key={device.id}>
                            <StyledTableCell>{device.group}</StyledTableCell>
                            <StyledTableCell>{device.model}</StyledTableCell>
                            <StyledTableCell>
                              {device.mac_address}
                            </StyledTableCell>
                            <StyledTableCell>
                              {device.imei_number}
                            </StyledTableCell>
                            <StyledTableCell>
                              {device.active_status === false
                                ? "Inactive"
                                : "Active"}
                            </StyledTableCell>
                            <StyledTableCell>
                              {device.imei_number === "NA"
                                ? timeStamp(parseInt(device.utc))
                                : timeStamp(parseInt(device.utc, 16))}
                              {/* {device.last_active.split("T")[0]} */}
                            </StyledTableCell>
                            <StyledTableCell>{device.comments}</StyledTableCell>
                            <StyledTableCell>
                              <Button
                              // variant="contained"
                              // onClick={() => {
                              //   handleClick(device.id);
                              // }}
                              >
                                <TextField
                                  select
                                  name="device_name"
                                  id="deviceName"
                                  sx={{ width: "clamp(80px, 12vw, 100px)" }}
                                  variant="outlined"
                                  label="Action"
                                  value=""
                                  // s
                                  onChange={(e) => {
                                    handleaction(
                                      device.id,
                                      e.target.value,
                                      device.imei_number,
                                    );
                                  }}
                                >
                                  <MenuItem value="Detail">Detail</MenuItem>
                                  <MenuItem
                                    value={
                                      device.active_status
                                        ? "Deactivate"
                                        : "Activate"
                                    }
                                  >
                                    {device.active_status
                                      ? "Deactivate"
                                      : "Activate"}
                                  </MenuItem>

                                  {loc.pathname === "/admin" && (
                                    <MenuItem value="Delete">
                                      Terminate
                                    </MenuItem>
                                  )}
                                </TextField>
                              </Button>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ) : (
              <h6 style={{ fontFamily: "Roboto" }}>No device added yet</h6>
            )}
          </Box>
          <Pagination
            count={totalpage}
            page={page}
            variant="outlined"
            color="primary"
            onChange={handlePagechange}
          />
          <NotificationContainer />
        </Card>
      )}
    </div>
  );
}
